/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
    UserToJSONTyped,
} from './User';

/**
 * Company invitation record
 * @export
 * @interface CompanyInvite
 */
export interface CompanyInvite {
    /**
     * 
     * @type {number}
     * @memberof CompanyInvite
     */
    readonly id: number;
    /**
     * 
     * @type {number}
     * @memberof CompanyInvite
     */
    readonly companyId: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyInvite
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyInvite
     */
    role: CompanyInviteRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof CompanyInvite
     */
    readonly token: string;
    /**
     * 
     * @type {number}
     * @memberof CompanyInvite
     */
    readonly invitedById: number;
    /**
     * 
     * @type {Date}
     * @memberof CompanyInvite
     */
    readonly expiresAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof CompanyInvite
     */
    readonly acceptedAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof CompanyInvite
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {User}
     * @memberof CompanyInvite
     */
    invitedBy?: User;
}


/**
 * @export
 */
export const CompanyInviteRoleEnum = {
    Admin: 'admin',
    Member: 'member'
} as const;
export type CompanyInviteRoleEnum = typeof CompanyInviteRoleEnum[keyof typeof CompanyInviteRoleEnum];


/**
 * Check if a given object implements the CompanyInvite interface.
 */
export function instanceOfCompanyInvite(value: object): value is CompanyInvite {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    if (!('token' in value) || value['token'] === undefined) return false;
    if (!('invitedById' in value) || value['invitedById'] === undefined) return false;
    if (!('expiresAt' in value) || value['expiresAt'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function CompanyInviteFromJSON(json: any): CompanyInvite {
    return CompanyInviteFromJSONTyped(json, false);
}

export function CompanyInviteFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyInvite {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'companyId': json['companyId'],
        'email': json['email'],
        'role': json['role'],
        'token': json['token'],
        'invitedById': json['invitedById'],
        'expiresAt': (new Date(json['expiresAt'])),
        'acceptedAt': json['acceptedAt'] == null ? undefined : (new Date(json['acceptedAt'])),
        'createdAt': (new Date(json['createdAt'])),
        'invitedBy': json['invitedBy'] == null ? undefined : UserFromJSON(json['invitedBy']),
    };
}

export function CompanyInviteToJSON(json: any): CompanyInvite {
    return CompanyInviteToJSONTyped(json, false);
}

export function CompanyInviteToJSONTyped(value?: Omit<CompanyInvite, 'id'|'companyId'|'token'|'invitedById'|'expiresAt'|'acceptedAt'|'createdAt'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'role': value['role'],
        'invitedBy': UserToJSON(value['invitedBy']),
    };
}

